import { createBrowserHistory } from '../../components/Breadcrumb/History';

const history = createBrowserHistory();

export default history;
